/**
 * date-fns locale for the current UI language. Patterns themselves live in
 * the catalogues under "formats", because Czech and English order and
 * punctuate dates differently.
 */

import { cs } from "date-fns/locale/cs";
import { enGB } from "date-fns/locale/en-GB";
import { getLang } from "./lang";

export const dateLocale = () => (getLang() === "en" ? enGB : cs);

/** BCP 47 tag for Intl and toLocaleDateString. */
export const localeTag = () => (getLang() === "en" ? "en-GB" : "cs-CZ");
